import React from 'react'
import './Profile.scss'
import { EmpProfile } from 'Pages/Frontend/Components'
import EmploymentInfo from 'Pages/Frontend/Components/EmployeeManager/Dashboard/ProfileOthers/EmploymentInfo/EmploymentInfo'
import Payroll from 'Pages/Frontend/Components/EmployeeManager/Dashboard/ProfileOthers/Payroll/Payroll'
import EducationInfo from 'Pages/Frontend/Components/EmployeeManager/Dashboard/ProfileOthers/EducationInfo/EducationInfo'
import HealthInfo from 'Pages/Frontend/Components/EmployeeManager/Dashboard/ProfileOthers/HealthInfo/HealthInfo'
import DocumentInfo from 'Pages/Frontend/Components/EmployeeManager/Dashboard/ProfileOthers/Documents/Document'
import PersonalInfoUser from 'Pages/Frontend/Components/EmployeeManager/Dashboard/ProfileOthers/PersonalInfo/PersonalInfo'
import { useResolvedProfile } from 'Hooks/useResolvedProfile'

function Profile() {
  const { profile, setProfile } = useResolvedProfile()

  return (
    <div className='profileV2'>
      <div className=''>
        <EmpProfile></EmpProfile>
      </div>
      <div className='personal-details mt-4'>
        <div className='card border-0'>
          <div className='card-header border-0 px-0 mb-0 pb-0'>
            <div className='head-tab'>
              <ul className='nav nav-pills' id='pills-tab' role='tablist'>
                <li className='nav-item' role='presentation'>
                  <button
                    className='nav-link active'
                    id='pills-home-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-home'
                    type='button'
                    role='tab'
                    aria-controls='pills-home'
                    aria-selected='true'
                  >
                    Personal Information
                  </button>
                </li>
                <li className='nav-item' role='presentation'>
                  <button
                    className='nav-link'
                    id='pills-employment-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-employment'
                    type='button'
                    role='tab'
                    aria-controls='pills-employment'
                    aria-selected='false'
                  >
                    Employment
                  </button>
                </li>
                <li className='nav-item' role='presentation'>
                  <button
                    className='nav-link'
                    id='pills-payroll-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-payroll'
                    type='button'
                    role='tab'
                    aria-controls='pills-payroll'
                    aria-selected='false'
                  >
                    Payroll & Statutory
                  </button>
                </li>
                <li className='nav-item' role='presentation'>
                  <button
                    className='nav-link'
                    id='pills-education-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-education'
                    type='button'
                    role='tab'
                    aria-controls='pills-education'
                    aria-selected='false'
                  >
                    Education & Experience
                  </button>
                </li>
                <li className='nav-item' role='presentation'>
                  <button
                    className='nav-link'
                    id='pills-health-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-health'
                    type='button'
                    role='tab'
                    aria-controls='pills-health'
                    aria-selected='false'
                  >
                    Health & Dependents
                  </button>
                </li>
                <li className='nav-item' role='presentation'>
                  <button
                    className='nav-link'
                    id='pills-doc-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-doc'
                    type='button'
                    role='tab'
                    aria-controls='pills-doc'
                    aria-selected='false'
                  >
                    Documents
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className='tab-content' id='pills-tabContent'>
            <div
              className='tab-pane fade show active'
              id='pills-home'
              role='tabpanel'
              aria-labelledby='pills-home-tab'
            >
              <PersonalInfoUser profile={profile} setProfile={setProfile} />
            </div>
            <div
              className='tab-pane fade'
              id='pills-employment'
              role='tabpanel'
              aria-labelledby='pills-employment-tab'
            >
              {' '}
              <EmploymentInfo profile={profile} setProfile={setProfile} />
            </div>
            <div
              className='tab-pane fade'
              id='pills-payroll'
              role='tabpanel'
              aria-labelledby='pills-payroll-tab'
            >
              {' '}
              <Payroll profile={profile} setProfile={setProfile} />
            </div>
            <div
              className='tab-pane fade'
              id='pills-education'
              role='tabpanel'
              aria-labelledby='pills-education-tab'
            >
              {' '}
              <EducationInfo profile={profile} setProfile={setProfile} />
            </div>
            <div
              className='tab-pane fade'
              id='pills-health'
              role='tabpanel'
              aria-labelledby='pills-health-tab'
            >
              {' '}
              <HealthInfo profile={profile} setProfile={setProfile} />
            </div>
            <div
              className='tab-pane fade'
              id='pills-doc'
              role='tabpanel'
              aria-labelledby='pills-doc-tab'
            >
              {' '}
              <DocumentInfo profile={profile} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
